import React from 'react';

/**
 * PageHeader — Common header component for all pages
 * Displays the page title in a styled gtss-bg-primary banner.
 * Has top rounded corners and flat bottom corners to seamlessly merge with the form card below.
 */
const PageHeader = ({ title, rightContent, standalone = false }) => {
    return (
        <div className={`px-4 py-3 gtss-bg-primary border d-flex justify-content-between align-items-center ${standalone ? 'rounded-3' : 'rounded-top-3 border-bottom-0'
            }`}>
            <h1 className="mb-0 fw-bold text-uppercase text-white fs-5">
                {title}
            </h1>
            {rightContent && (
                <div className="text-white fw-bold fs-5 text-truncate ms-3 text-end" style={{ maxWidth: '50%' }}>
                    {rightContent}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
